import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MISSION_TYPES, missionLabel } from "@/lib/labels";
import DeliverableStudio from "@/components/app/DeliverableStudio";

function LetterFormFields(form, setForm, clients) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="md:col-span-2">
        <Label>Client *</Label>
        <Select value={form.client_id} onValueChange={(v) => setForm({ ...form, client_id: v })}>
          <SelectTrigger data-testid="letter-client"><SelectValue placeholder="Sélectionner un client" /></SelectTrigger>
          <SelectContent>{clients.map((c) => (<SelectItem key={c.id} value={c.id}>{c.name} · {c.country}</SelectItem>))}</SelectContent>
        </Select>
      </div>
      <div className="md:col-span-2">
        <Label>Type de mission *</Label>
        <Select value={form.mission_type} onValueChange={(v) => setForm({ ...form, mission_type: v })}>
          <SelectTrigger data-testid="letter-type"><SelectValue /></SelectTrigger>
          <SelectContent>{MISSION_TYPES.map((m) => (<SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>))}</SelectContent>
        </Select>
      </div>
      <div><Label>Honoraires HT</Label><Input type="number" step="0.01" value={form.fees_ht} onChange={(e) => setForm({ ...form, fees_ht: e.target.value })} /></div>
      <div><Label>Durée</Label><Input placeholder="12 mois, exercice 2025…" value={form.duration} onChange={(e) => setForm({ ...form, duration: e.target.value })} /></div>
      <div className="md:col-span-2">
        <Label>Contexte spécifique</Label>
        <Textarea rows={3} value={form.specific_context} onChange={(e) => setForm({ ...form, specific_context: e.target.value })} placeholder="Particularités du dossier, taille, éléments à intégrer…" />
      </div>
    </div>
  );
}

const INITIAL_FORM = { client_id: "", mission_type: "tenue_comptable", fees_ht: "", duration: "", specific_context: "" };

export default function EngagementLetters() {
  return (
    <DeliverableStudio
      kind="lettre_mission"
      generateEndpoint="/engagement-letters/generate"
      eyebrow="Livrables IA"
      title="Lettres de mission"
      description="Rédaction assistée par IA — Times New Roman 12 justifié, exportable Word."
      dialogTitle="Nouvelle lettre de mission"
      generateButtonLabel="Générer une lettre"
      generateTestid="generate-letter-btn"
      initialForm={INITIAL_FORM}
      renderFormFields={LetterFormFields}
      buildPayload={(form) => ({
        client_id: form.client_id,
        mission_type: form.mission_type,
        fees_ht: form.fees_ht ? parseFloat(form.fees_ht) : null,
        duration: form.duration || null,
        specific_context: form.specific_context || null,
      })}
      canSubmit={(form) => !!form.client_id}
      historyTitleFn={(it, clientMap) => clientMap[it.client_id]?.name || "Client"}
      historySubtitleFn={(it) => missionLabel(it.mission_type)}
      detailTitleFn={(s, clientMap) => clientMap[s.client_id]?.name || "—"}
      detailEyebrow="Lettre de mission"
      emptyText="Aucune lettre pour l'instant."
      emptyHint="Sélectionnez une lettre ou générez-en une nouvelle."
      testidPrefix="letter"
    />
  );
}
